import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "assets/icons/close.svg?react";
import budgetService from "api/budgetService";
import { budgetDialogPaperProps } from "components/Budget/budgetDialog";
import { IBudgetEngagement } from "dto/Budget/IBudgetEngagement";
import { formatMoney } from "utils/formatMoney";
import styles from "./styles.module.scss";

interface Props {
  engagement: IBudgetEngagement;
  onClose: () => void;
}

const formatDate = (iso?: string) => (iso ? iso.slice(0, 10) : "—");

const BudgetEngagementSettlementsModal = ({ engagement, onClose }: Props) => {
  const { data: invoices = [] } = budgetService.useGetEngagementInvoices(
    engagement.Id,
  );

  const total = invoices.reduce((s, i) => s + i.Amount, 0);

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={budgetDialogPaperProps}
    >
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <span className={styles.title}>Rozliczenia zaangażowania</span>
          <IconButton onClick={onClose} size="small" className={styles.close}>
            <CloseIcon className={styles.closeIcon} />
          </IconButton>
        </div>

        <div className={styles.engagementTitle}>{engagement.Title}</div>
        {engagement.Signature && (
          <div className={styles.signature}>{engagement.Signature}</div>
        )}

        <div className={styles.list}>
          <div className={styles.rowHead}>
            <span>Nr</span>
            <span>Faktura</span>
            <span>Kontrahent</span>
            <span className={styles.right}>Data</span>
            <span className={styles.right}>Kwota</span>
          </div>
          {invoices.length === 0 ? (
            <div className={styles.empty}>Brak rozliczeń</div>
          ) : (
            invoices.map((inv) => (
              <div className={styles.row} key={inv.Id}>
                <span>{inv.Number}</span>
                <span className={styles.itemTitle}>{inv.Title}</span>
                <span className={styles.itemSub}>{inv.Sender}</span>
                <span className={styles.right}>{formatDate(inv.Date)}</span>
                <span className={styles.right}>{formatMoney(inv.Amount)}</span>
              </div>
            ))
          )}
        </div>

        {invoices.length > 0 && (
          <div className={styles.total}>
            <span>Rozliczono razem</span>
            <strong>{formatMoney(total)}</strong>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default BudgetEngagementSettlementsModal;
